/**
 * Helper to return control to the main thread. This is helpful when needing
 * to render a UI state change before running a long-running blocking operation.
 *
 * Without yielding control, the UI wont update until the blocking operation completes.
 * Ideally, the new `Scheduler.yield()` API would be used instead but it's not yet supported in
 * every major browser (`https://developer.mozilla.org/en-US/docs/Web/API/Scheduler/yield`)
 *
 * @example
 * setLoading(true);
 * await yieldToMain()
 * longRunningOperation();
 * setLoading(false);
 *
 */
export async function yieldToMain() {
  return new Promise(resolve => { setTimeout(resolve, 0); });
}
